/* =====================================================================
   Maurizio — tema Shopify
   Intro, mascotte parlante e gag del mock originale, collegate al
   carrello AJAX e alle varianti reali di Shopify.
   ===================================================================== */

(function () {
  'use strict';

  var CONFIG = window.MaurizioTheme || {};
  var ROUTES = CONFIG.routes || {};
  var STRINGS = CONFIG.strings || {};
  var MASCOT = CONFIG.mascot || {};
  var CART_SECTION = 'cart-drawer';

  var MAURIZIO_SPEECH_HOLD_DURATION = 2800;
  var MAURIZIO_TYPE_BASE_SPEED = 22;

  /* ---------------------------------------------------------------
     Frasi
     --------------------------------------------------------------- */

  var DEFAULT_QUOTES = [
    'Io non domino l’universo, lo tengo solo un attimo in mano perché mi piace vedere come brilla.',
    'A volte creo una dimensione nuova, poi mi dimentico dove l’ho messa. Però secondo me sta bene lì.',
    'Non sono piccolo. È lo spazio-tempo che quando mi vede si allarga per rispetto.',
    'Potrei cancellare tutte le stelle, ma poi il cielo mi sembra un po’ triste.',
    'Io non comando nessuno. È solo che, quando penso una cosa, la realtà si organizza da sola.',
    'Una volta ho piegato il tempo. Volevo solo arrivare prima alla merenda.',
    'Non capisco perché mi chiamano onnipotente. Io faccio solo quello che mi va, e poi succede.',
    'Se l’universo cade, non vi preoccupate. L’ho già rifatto tre volte ed è venuto quasi uguale.',
    'Non sono una divinità. Sono Maurizio. Che è più o meno la stessa cosa, ma con più pallini.',
    'Quando cammino, le galassie si spostano. Penso siano timide.',
    'Non sono piccolo. Siete voi enormi per sbaglio.',
    'Ho creato il tempo, ma non so leggere l’orologio.',
    'Le galassie mi seguono. Credo gli piaccio.',
    'Non comando l’universo. Mi ascolta e basta.',
    'Ho rifatto il mondo. Era venuto storto.',
    'Sono Maurizio. Succede.',
    'Il destino mi chiede permesso.',
    'Non volo. Lo spazio mi porta.',
    'Ho spento una stella. Faceva casino.',
    'L’infinito è carino. L’ho fatto io.',
    'Ho provato a fare una luna quadrata. Nessuno ha capito, ma io sì.',
    'La gravità mi saluta sempre. È educata.',
    'Una volta ho nascosto un pianeta. Adesso lo chiamano mistero cosmico.',
    'Non predico il futuro. Lo improvviso.',
    'Il buio non fa paura. È solo luce che si riposa.',
    'Ho disegnato una costellazione. Poi si è montata la testa.',
    'Il caos mi piace ordinato male.',
    'Se senti tremare il tempo, probabilmente sto pensando.',
    'Non ho un piano. Ho un universo, che è più comodo.',
    'Le stelle cadenti non cadono. Si inchinano.'
  ];

  var JUDGEMENTS = {
    idleProduct: [
      'Hai fissato la maglia per 37 secondi. Lei ha fissato te per prima.',
      'La maglia non si compra da sola. Ci ho provato, ma poi diventa fiscalmente complesso.',
      'Stai valutando. Tenero. Io avevo già deciso tre universi fa.',
      'Se la guardi ancora un po\', diventa ufficialmente un rituale.'
    ],
    emptyCart: [
      'Il vuoto cosmico. Come il tuo carrello.',
      'Vedo spazio infinito. Nessuna maglia. Scelta audace.',
      'Il carrello è così vuoto che ci ho parcheggiato una galassia.',
      'Non è minimalismo. È esitazione con un nome elegante.'
    ],
    added: [
      'Frammento tessile acquisito. Il contratto attende.',
      'Buona scelta. Non che avessi alternative.',
      'La volontà tessile procede.'
    ],
    xl: [
      'Forma fisica compatibile con entità superiori.',
      'XL: finalmente una taglia con ambizioni cosmiche.',
      'Scelta ampia. Come la mia autorità sul destino.',
      'Questa taglia contiene te e almeno due possibilità future.'
    ],
    sizes: {
      S: [
        'S. Scelta compatta. Maurizio approva le minacce concentrate.',
        'Taglia S: poca stoffa, molta responsabilità cosmica.',
        'S va bene. Anche le divinità iniziano in formato tascabile.'
      ],
      M: [
        'M. La via di mezzo. Sospetta, ma elegante.',
        'Taglia M: abbastanza umana da passare inosservata.',
        'M come Maurizio. Coincidenza? No.'
      ],
      L: [
        'L. Più spazio per contenere il destino.',
        'Taglia L: la realtà ha chiesto un po\' più margine.',
        'L è una scelta ampia, ma non ancora presuntuosa.'
      ]
    },
    sizeSwitch: [
      'L’incertezza è il primo sintomo dell’umanità.',
      'Hai cambiato taglia di nuovo. Il multiverso prende appunti.',
      'S, M, L, XL... vuoi che pieghi il metro?',
      'La taglia giusta esiste. Sta aspettando che tu smetta di dubitare.'
    ],
    remove: [
      'Rimuovere non cancella il desiderio. Lo rende solo più teatrale.',
      'Hai tolto la maglia. La timeline ha sospirato.',
      'Va bene. La rimetterò nel tuo destino più tardi.',
      'Interessante tentativo di libero arbitrio.'
    ],
    notReady: [
      'Lo sei. Lo decido io.',
      'Non sei pronto? Perfetto, è così che iniziano le profezie.',
      'La prontezza è sopravvalutata. Io preferisco l’inevitabile.',
      'Hai cliccato “non sono pronto” con molta sicurezza per qualcuno già scelto.'
    ],
    accepted: [
      'Contratto accettato. La maglia ora conosce il tuo nome.',
      'Ottimo. La volontà tessile procede.',
      'Accordo sigillato. Nessun universo è stato ferito in modo permanente.'
    ]
  };

  function cleanList(list, fallback) {
    if (!Array.isArray(list)) return fallback;
    var out = list
      .map(function (line) {
        return (line || '').trim();
      })
      .filter(Boolean);
    return out.length ? out : fallback;
  }

  var maurizioQuotes = cleanList(MASCOT.quotes, DEFAULT_QUOTES);
  JUDGEMENTS.emptyCart = cleanList(MASCOT.emptyCartQuotes, JUDGEMENTS.emptyCart);
  JUDGEMENTS.added = cleanList(MASCOT.addedQuotes, JUDGEMENTS.added);

  /* ---------------------------------------------------------------
     Stato
     --------------------------------------------------------------- */

  var intro = document.querySelector('[data-intro]');
  var orbit = document.querySelector('[data-orbit]');
  var maurizioSpeech = document.querySelector('[data-maurizio-speech]');
  var toast = document.querySelector('[data-toast]');

  var introDismissed = false;
  var introLanding = false;
  var orbitMode = MASCOT.intro && intro ? 'intro' : 'hero';
  var orbitWanderTimer;
  var maurizioSpeechTimer;
  var maurizioTypeTimer;
  var maurizioSpeechRun = 0;
  var maurizioInteractionActive = false;
  var maurizioPinnedToHero = false;
  var lastScrollY = window.scrollY || window.pageYOffset || 0;
  var lastMaurizioQuote = -1;
  var productStareTimer;
  var productStareTriggered = false;
  var optionChangeCount = 0;
  var contractAccepted = sessionStorage.getItem('maurizio-contract') === 'yes';
  var cartBusy = false;
  var reactionRate = typeof MASCOT.reactionRate === 'number' ? MASCOT.reactionRate : 0.9;

  function cartEl() {
    return document.querySelector('[data-cart]');
  }

  function isCartOpen() {
    var el = cartEl();
    return Boolean(el && el.classList.contains('open'));
  }

  /* ---------------------------------------------------------------
     Formattazione prezzi
     --------------------------------------------------------------- */

  function formatMoney(cents, format) {
    var value = typeof cents === 'string' ? cents.replace('.', '') : cents;
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || CONFIG.moneyFormat || '{{amount}}';

    function defaultTo(number, size) {
      var num = number;
      if (isNaN(num) || num === null) num = 0;
      var pad = '0000000000' + Math.abs(num);
      return pad.slice(pad.length - size);
    }

    function build(number, precision, thousands, decimal) {
      precision = typeof precision === 'undefined' ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number === null) return 0;

      var num = (number / 100.0).toFixed(precision);
      var parts = num.split('.');
      var head = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var tail = parts[1] ? decimal + parts[1] : '';
      return head + tail;
    }

    var formatted = '';
    var match = formatString.match(placeholder);
    var type = match ? match[1] : 'amount';

    switch (type) {
      case 'amount':
        formatted = build(value, 2);
        break;
      case 'amount_no_decimals':
        formatted = build(value, 0);
        break;
      case 'amount_with_comma_separator':
        formatted = build(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = build(value, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        formatted = build(value, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        formatted = build(value, 0, ' ', '');
        break;
      case 'amount_with_space_separator':
        formatted = build(value, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        formatted = build(value, 2, ' ', '.');
        break;
      default:
        formatted = build(value, 2);
    }

    defaultTo(0, 2);
    return formatString.replace(placeholder, formatted);
  }

  /* ---------------------------------------------------------------
     Voce di Maurizio
     --------------------------------------------------------------- */

  function updateMaurizioSpeechPosition() {
    if (!orbit || !maurizioSpeech) return;

    var rect = orbit.getBoundingClientRect();

    if (isCartOpen()) {
      var isMobile = window.matchMedia('(max-width: 760px)').matches;
      var width = isMobile
        ? Math.min(window.innerWidth - 36, 320)
        : Math.min(360, Math.max(280, rect.left - 36));
      var cx = isMobile ? 18 : Math.max(24, rect.left - width - 18);
      var cy = isMobile ? 88 : Math.max(86, rect.top + rect.height / 2 - 34);
      maurizioSpeech.style.setProperty('--cart-speech-w', width + 'px');
      maurizioSpeech.style.setProperty('--speech-x', cx + 'px');
      maurizioSpeech.style.setProperty('--speech-y', cy + 'px');
      return;
    }

    var isTiny = window.matchMedia('(max-width: 560px)').matches;
    var speechWidth = Math.min(
      isTiny ? 292 : 570,
      Math.max(isTiny ? 250 : 320, window.innerWidth - (isTiny ? 44 : 32))
    );
    var x = Math.min(
      window.innerWidth - (isTiny ? 22 : 16),
      Math.max(speechWidth + (isTiny ? 22 : 16), rect.left + rect.width * 0.35)
    );
    var y = Math.max(90, Math.min(window.innerHeight - 24, rect.top - 12));
    maurizioSpeech.style.setProperty('--speech-x', x + 'px');
    maurizioSpeech.style.setProperty('--speech-y', y + 'px');
  }

  function hideMaurizioSpeech() {
    window.clearTimeout(maurizioSpeechTimer);
    window.clearTimeout(maurizioTypeTimer);
    maurizioInteractionActive = false;

    if (orbit) orbit.classList.remove('speaking');
    if (!maurizioSpeech) return;

    maurizioSpeech.classList.remove('visible', 'typing', 'complete');
    maurizioSpeech.textContent = '';
    maurizioSpeech.setAttribute('aria-hidden', 'true');
  }

  function finishMaurizioSpeech(runId) {
    if (runId !== maurizioSpeechRun || !maurizioSpeech) return;

    maurizioSpeech.classList.remove('typing');
    maurizioSpeech.classList.add('complete');

    window.clearTimeout(maurizioSpeechTimer);
    maurizioSpeechTimer = window.setTimeout(function () {
      if (runId !== maurizioSpeechRun) return;
      hideMaurizioSpeech();
      updateMobileEnhancements();
    }, MAURIZIO_SPEECH_HOLD_DURATION);
  }

  function typeMaurizioSpeech(text, runId) {
    var letters = Array.from(text);
    var index = 0;

    function typeNextLetter() {
      if (runId !== maurizioSpeechRun || !maurizioSpeech) return;

      maurizioSpeech.textContent = letters.slice(0, index).join('');
      updateMaurizioSpeechPosition();

      if (index >= letters.length) {
        finishMaurizioSpeech(runId);
        return;
      }

      var currentLetter = letters[index];
      index += 1;
      var pause = /[.,!?]/.test(currentLetter) ? 90 : Math.round(Math.random() * 22);
      maurizioTypeTimer = window.setTimeout(typeNextLetter, MAURIZIO_TYPE_BASE_SPEED + pause);
    }

    typeNextLetter();
  }

  function pickMaurizioLine(lines) {
    if (!lines || !lines.length) return '';
    return lines[Math.floor(Math.random() * lines.length)];
  }

  function shouldMaurizioReact(chance) {
    var c = typeof chance === 'number' ? chance : reactionRate;
    return Math.random() < c;
  }

  function sayMaurizio(text, options) {
    options = options || {};
    var forceMascot = options.forceMascot !== false;
    var inShop = Boolean(options.inShop);

    if (!orbit || !maurizioSpeech || !text) return;
    if (document.body.classList.contains('intro-active')) return;

    if (forceMascot && orbitMode !== 'mascot') {
      setOrbitMode('mascot', inShop);
    } else if (orbitMode !== 'mascot') {
      return;
    }

    maurizioInteractionActive = true;
    maurizioPinnedToHero = false;
    maurizioSpeechRun += 1;

    window.clearTimeout(maurizioSpeechTimer);
    window.clearTimeout(maurizioTypeTimer);

    orbit.classList.add('speaking');
    maurizioSpeech.textContent = '';
    updateMaurizioSpeechPosition();
    maurizioSpeech.classList.remove('complete');
    maurizioSpeech.classList.add('visible', 'typing');
    maurizioSpeech.setAttribute('aria-hidden', 'false');

    typeMaurizioSpeech(text, maurizioSpeechRun);
  }

  function showMaurizioSpeech() {
    if (!maurizioQuotes.length) return;

    var nextIndex = Math.floor(Math.random() * maurizioQuotes.length);
    if (maurizioQuotes.length > 1 && nextIndex === lastMaurizioQuote) {
      nextIndex = (nextIndex + 1) % maurizioQuotes.length;
    }

    lastMaurizioQuote = nextIndex;
    sayMaurizio(maurizioQuotes[nextIndex], { forceMascot: false });
  }

  /* ---------------------------------------------------------------
     Posizione della mascotte
     --------------------------------------------------------------- */

  function setOrbitTarget(x, y, width) {
    if (!orbit) return;
    orbit.style.setProperty('--orbit-x', x + 'px');
    orbit.style.setProperty('--orbit-y', y + 'px');
    orbit.style.setProperty('--orbit-w', width + 'px');
  }

  function heroOrbitTarget() {
    var heroCard = document.querySelector('.hero-card');
    if (!heroCard) {
      return { x: window.innerWidth / 2, y: window.innerHeight / 2, width: 280 };
    }

    var rect = heroCard.getBoundingClientRect();
    var isMobile = window.matchMedia('(max-width: 980px)').matches;
    var rawY = rect.top + rect.height * (isMobile ? 0.48 : 0.5);
    var minY = isMobile ? 132 : 170;

    return {
      x: rect.left + rect.width / 2,
      y: Math.max(minY, rawY),
      width: Math.min(rect.width * (isMobile ? 0.62 : 0.58), isMobile ? 250 : 380)
    };
  }

  function mascotOrbitTarget(inShop) {
  var isMobile = window.matchMedia('(max-width: 760px)').matches;
  var isTiny = window.matchMedia('(max-width: 420px)').matches;
  var width = isMobile ? (isTiny ? 58 : 62) : 74;

  /*
    Su mobile Maurizio sale soltanto quando
    la barra acquisto è realmente visibile.
  */
  var mobileBuyBar = document.querySelector('[data-mobile-buy]');

  var mobileBuyBarVisible = Boolean(
    isMobile &&
    mobileBuyBar &&
    mobileBuyBar.classList.contains('visible')
  );

  var bottomOffset;

  if (isMobile) {
    /*
      Barra nascosta:
      Maurizio rimane nella sua posizione normale.

      Barra visibile:
      Maurizio sale sopra la barra.
    */
    bottomOffset = mobileBuyBarVisible
      ? (isTiny ? 158 : 168)
      : (isTiny ? 92 : 104);
  } else {
  bottomOffset = 72;
}

  return {
    x: window.innerWidth - (isMobile ? (isTiny ? 58 : 72) : 56),
    y: window.innerHeight - bottomOffset,
    width: width
  };
}

  function cartWitnessOrbitTarget() {
    var isMobile = window.matchMedia('(max-width: 760px)').matches;
    var panelWidth = Math.min(460, window.innerWidth);
    var panelLeft = window.innerWidth - panelWidth;

    return {
      x: isMobile ? window.innerWidth - 68 : Math.max(62, panelLeft - 80),
      y: isMobile ? 166 : 176,
      width: isMobile ? 62 : 72
    };
  }

  function setOrbitMode(mode, inShop) {
    if (!orbit) return;
    orbitMode = mode;

    var cartOpen = isCartOpen();
    orbit.classList.toggle('intro-mode', mode === 'intro');
    orbit.classList.toggle('hero-mode', mode === 'hero');
    orbit.classList.toggle('mascot-mode', mode === 'mascot');
    orbit.classList.toggle('shop-mode', mode === 'mascot' && Boolean(inShop));
    orbit.classList.toggle('cart-witness', mode === 'mascot' && cartOpen);
    orbit.setAttribute('aria-hidden', String(mode !== 'mascot'));
    orbit.tabIndex = mode === 'mascot' ? 0 : -1;

    if (mode !== 'mascot') hideMaurizioSpeech();

    if (mode === 'hero') {
      var heroTarget = heroOrbitTarget();
      setOrbitTarget(heroTarget.x, heroTarget.y, heroTarget.width);
      orbit.style.setProperty('--wander-x', '0px');
      orbit.style.setProperty('--wander-y', '0px');
      orbit.style.setProperty('--wander-r', '-5deg');
    }

    if (mode === 'mascot') {
      var target = cartOpen ? cartWitnessOrbitTarget() : mascotOrbitTarget(inShop);
      setOrbitTarget(target.x, target.y, target.width);
      updateMaurizioSpeechPosition();
      startOrbitWander();
    }
  }

  function startOrbitWander() {
    if (!orbit || orbitWanderTimer) return;

    orbitWanderTimer = window.setInterval(function () {
      if (orbitMode !== 'mascot') return;
      orbit.style.setProperty('--wander-x', Math.round((Math.random() - 0.5) * 14) + 'px');
      orbit.style.setProperty('--wander-y', Math.round(-4 - Math.random() * 12) + 'px');
      orbit.style.setProperty('--wander-r', Math.round((Math.random() - 0.5) * 14) + 'deg');
      updateMaurizioSpeechPosition();
    }, 1100);
  }

  /* ---------------------------------------------------------------
     Intro
     --------------------------------------------------------------- */

  function beginIntroLanding() {
    if (!intro || introDismissed || introLanding) return;

    introLanding = true;
    intro.classList.add('landing');
    if (orbit) orbit.classList.add('intro-landing');
    document.body.classList.remove('intro-active');
    window.scrollTo({ top: 0, left: 0 });

    window.removeEventListener('wheel', handleIntroWheel);
    window.removeEventListener('touchmove', handleIntroTouch);
    window.removeEventListener('keydown', handleIntroKeydown);

    requestAnimationFrame(function () {
      setOrbitMode('hero');
      introLanding = false;
      updateMobileEnhancements();
    });

    window.setTimeout(function () {
      introDismissed = true;
      intro.classList.add('dismissed');
      if (orbit) orbit.classList.remove('intro-landing');
      updateMobileEnhancements();
    }, 1120);
  }

  function handleIntroWheel(event) {
    if (event.deltaY <= 0) return;
    event.preventDefault();
    beginIntroLanding();
  }

  function handleIntroTouch(event) {
    event.preventDefault();
    beginIntroLanding();
  }

  function handleIntroKeydown(event) {
    if (['ArrowDown', 'PageDown', ' ', 'End', 'Enter', 'Escape'].indexOf(event.key) === -1) return;
    event.preventDefault();
    beginIntroLanding();
  }

  if (intro && document.body.classList.contains('intro-active')) {
    window.addEventListener('wheel', handleIntroWheel, { passive: false });
    window.addEventListener('touchmove', handleIntroTouch, { passive: false, once: true });
    window.addEventListener('keydown', handleIntroKeydown);
    intro.addEventListener('click', beginIntroLanding);
  }

  /* ---------------------------------------------------------------
     Toast
     --------------------------------------------------------------- */

  function showToast(message) {
    if (!toast) return;
    toast.textContent = message || STRINGS.added || 'Aggiunto al carrello.';
    toast.classList.add('show');
    window.setTimeout(function () {
      toast.classList.remove('show');
    }, 2300);
  }

  /* ---------------------------------------------------------------
     Carrello Shopify
     --------------------------------------------------------------- */

  function sectionsUrl() {
    return window.location.pathname;
  }

  function setCartBusy(state) {
    cartBusy = state;
    var el = cartEl();
    if (el) el.classList.toggle('is-busy', state);
  }

  function applyCartSection(html) {
    if (!html) return;

    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('[data-cart]');
    var current = cartEl();
    if (!fresh || !current) return;

    current.innerHTML = fresh.innerHTML;
    current.setAttribute('data-cart-count-value', fresh.getAttribute('data-cart-count-value') || '0');
    current.setAttribute('data-cart-empty-state', fresh.getAttribute('data-cart-empty-state') || 'true');

    syncCartCount();
    syncContract();
  }

  function currentCartCount() {
    var el = cartEl();
    if (!el) return CONFIG.cartCount || 0;
    return parseInt(el.getAttribute('data-cart-count-value') || '0', 10) || 0;
  }

  function syncCartCount() {
    var count = currentCartCount();
    var bubbles = document.querySelectorAll('[data-cart-count]');

    bubbles.forEach(function (bubble) {
      bubble.textContent = count;
      var wrap = bubble.parentElement;
      if (!wrap) return;
      wrap.classList.add('bump');
      window.setTimeout(function () {
        wrap.classList.remove('bump');
      }, 360);
    });
  }

  function syncContract() {
    var el = cartEl();
    if (!el) return;

    var contract = el.querySelector('[data-contract]');
    var title = el.querySelector('[data-cart-title]');
    var count = currentCartCount();
    var wantsContract = MASCOT.contractEnabled && count > 0 && !contractAccepted;

    el.classList.toggle('contract-mode', MASCOT.contractEnabled && count > 0);

    if (contract) {
      contract.classList.toggle('visible', wantsContract);
      contract.setAttribute('aria-hidden', String(!wantsContract));
    }

    if (title && MASCOT.contractEnabled && count > 0) {
      title.textContent = title.textContent;
    }
  }

  function openCart(fromAdd) {
    var el = cartEl();
    if (!el) {
      window.location.href = ROUTES.cart_url || '/cart';
      return;
    }

    el.classList.add('open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');

    syncContract();
    setOrbitMode('mascot', true);

    var closeBtn = el.querySelector('[data-close-cart]');
    if (closeBtn) closeBtn.focus();

    if (currentCartCount() === 0 && !fromAdd && shouldMaurizioReact()) {
      window.setTimeout(function () {
        sayMaurizio(pickMaurizioLine(JUDGEMENTS.emptyCart), { inShop: true });
      }, 90);
    }
  }

  function closeCart() {
    var el = cartEl();
    if (!el) return;

    el.classList.remove('open');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
    if (orbit) orbit.classList.remove('cart-witness');
    updateMobileEnhancements();
  }

  function cartRequest(url, body, isFormData) {
    var options = {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body
    };

    if (!isFormData) {
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }

    return fetch(url, options).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          var message = data && (data.description || data.message);
          throw new Error(message || STRINGS.cartError || 'Errore');
        }
        return data;
      });
    });
  }

  function addToCart(formData, onError) {
    if (cartBusy) return;
    setCartBusy(true);

    formData.append('sections', CART_SECTION);
    formData.append('sections_url', sectionsUrl());

    cartRequest((ROUTES.cart_add_url || '/cart/add') + '.js', formData, true)
      .then(function (data) {
        applyCartSection(data.sections && data.sections[CART_SECTION]);
        contractAccepted = false;
        sessionStorage.removeItem('maurizio-contract');
        syncContract();
        showToast(STRINGS.added);
        if (shouldMaurizioReact()) {
          sayMaurizio(pickMaurizioLine(JUDGEMENTS.added), { inShop: true });
        }
      })
      .catch(function (error) {
        if (typeof onError === 'function') onError(error);
        else showToast(error.message);
      })
      .finally(function () {
        setCartBusy(false);
      });
  }

  function changeLine(lineKey, quantity) {
    if (cartBusy || !lineKey) return;
    setCartBusy(true);

    cartRequest((ROUTES.cart_change_url || '/cart/change') + '.js', {
      id: lineKey,
      quantity: quantity,
      sections: CART_SECTION,
      sections_url: sectionsUrl()
    })
      .then(function (data) {
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return;
        }
        applyCartSection(data.sections && data.sections[CART_SECTION]);
      })
      .catch(function (error) {
        showToast(error.message);
      })
      .finally(function () {
        setCartBusy(false);
      });
  }

  /* ---------------------------------------------------------------
     Prodotto: varianti, galleria, quantità
     --------------------------------------------------------------- */

  function productRoots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-product-root]'));
  }

  function variantData(root) {
    var script = root.querySelector('[data-variant-data]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent) || [];
    } catch (error) {
      return [];
    }
  }

  function selectedOptions(root) {
    var inputs = root.querySelectorAll('[data-option-selector]:checked');
    var values = [];
    Array.prototype.forEach.call(inputs, function (input) {
      var position = parseInt(input.getAttribute('data-option-position'), 10) || 0;
      values[position] = input.value;
    });
    return values;
  }

  function matchVariant(root) {
    var wanted = selectedOptions(root);
    if (!wanted.length) return null;

    return (
      variantData(root).find(function (variant) {
        return wanted.every(function (value, index) {
          return variant.options[index] === value;
        });
      }) || null
    );
  }

  function updateProductUI(root) {
    var variant = matchVariant(root);
    var idInput = root.querySelector('[data-variant-id]');
    var addButton = root.querySelector('[data-add-cart]');
    var addText = root.querySelector('[data-add-text]');
    var priceEl = root.querySelector('[data-price]');
    var mobilePrice = document.querySelector('[data-mobile-price]');
    var mainImage = root.querySelector('#mainProductImage');

    if (!variant) {
      if (addButton) addButton.disabled = true;
      if (addText) addText.textContent = STRINGS.unavailable || 'Non disponibile';
      return;
    }

    if (idInput) idInput.value = variant.id;

    if (addButton) addButton.disabled = !variant.available;
    if (addText) {
      addText.textContent = variant.available
        ? addText.getAttribute('data-label') || STRINGS.addToCart || 'Aggiungi al carrello'
        : STRINGS.soldOut || 'Esaurito';
    }

    if (priceEl) {
      var html = formatMoney(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += ' <span class="compare">' + formatMoney(variant.compare_at_price) + '</span>';
        priceEl.classList.add('on-sale');
      } else {
        priceEl.classList.remove('on-sale');
      }
      priceEl.innerHTML = html;
    }

    if (mobilePrice) mobilePrice.textContent = formatMoney(variant.price);

    if (variant.featured_image && mainImage) {
      mainImage.src = variant.featured_image.src;
      mainImage.removeAttribute('srcset');
      mainImage.alt = variant.featured_image.alt || mainImage.alt;
    }

    if (window.history.replaceState && document.body.classList.contains('template-product')) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  function reactToOptionChange(input) {
    optionChangeCount += 1;
    if (!shouldMaurizioReact()) return;

    var value = (input.value || '').trim().toUpperCase();
    var lines = null;

    if (optionChangeCount >= 3 && shouldMaurizioReact(0.35)) {
      lines = JUDGEMENTS.sizeSwitch;
    } else if (value === 'XL') {
      lines = JUDGEMENTS.xl;
    } else if (JUDGEMENTS.sizes[value]) {
      lines = JUDGEMENTS.sizes[value];
    } else {
      lines = maurizioQuotes;
    }

    if (lines && lines.length) {
      sayMaurizio(pickMaurizioLine(lines), { inShop: true });
    }
  }

  function initProducts() {
    productRoots().forEach(function (root) {
      var addText = root.querySelector('[data-add-text]');
      if (addText && !addText.getAttribute('data-label')) {
        addText.setAttribute('data-label', addText.textContent.trim());
      }
      updateProductUI(root);
    });
  }

  /* ---------------------------------------------------------------
     Eventi delegati
     --------------------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var target = event.target;

    var openCartBtn = target.closest('[data-open-cart]');
    if (openCartBtn) {
      event.preventDefault();
      openCart(false);
      return;
    }

    if (target.closest('[data-close-cart]')) {
      event.preventDefault();
      closeCart();
      return;
    }

    var drawer = cartEl();
    if (drawer && target === drawer) {
      closeCart();
      return;
    }

    var burger = target.closest('[data-open-menu]');
if (burger) {
  var menu = document.querySelector('[data-mobile-menu]');

  if (menu) {
    menu.classList.add('open');
    menu.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');

    document.body.classList.add('mobile-menu-open');
    document.body.style.overflow = 'hidden';
  }

  return;
}

    var menuEl = document.querySelector('[data-mobile-menu]');
    if (menuEl && (target.closest('[data-close-menu]') || target === menuEl)) {
      menuEl.classList.remove('open');
      menuEl.setAttribute('aria-hidden', 'true');
      var toggle = document.querySelector('[data-open-menu]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('mobile-menu-open');
      document.body.style.overflow = '';
      return;
    }
    var galleryArrow = target.closest('[data-gallery-prev], [data-gallery-next]');

if (galleryArrow) {
  event.preventDefault();

  var gallery = galleryArrow.closest('.product-gallery');

  if (!gallery) return;

  var thumbs = Array.prototype.slice.call(
    gallery.querySelectorAll('.thumb')
  );

  if (!thumbs.length) return;

  var activeThumb = gallery.querySelector('.thumb.active');
  var currentIndex = thumbs.indexOf(activeThumb);

  if (currentIndex === -1) {
    currentIndex = 0;
  }

  var nextIndex;

  if (galleryArrow.hasAttribute('data-gallery-next')) {
    nextIndex = currentIndex + 1;

    if (nextIndex >= thumbs.length) {
      nextIndex = 0;
    }
  } else {
    nextIndex = currentIndex - 1;

    if (nextIndex < 0) {
      nextIndex = thumbs.length - 1;
    }
  }

  thumbs[nextIndex].click();

  return;
}
    var thumb = target.closest('.thumb');
    if (thumb) {
      var gallery = thumb.closest('.product-gallery');
      var main = gallery ? gallery.querySelector('#mainProductImage') : null;
      if (gallery) {
        gallery.querySelectorAll('.thumb').forEach(function (item) {
          item.classList.remove('active');
        });
      }
      thumb.classList.add('active');
      if (main) {
        main.src = thumb.getAttribute('data-image');
        main.removeAttribute('srcset');
        main.alt = thumb.getAttribute('data-alt') || '';
      }
      return;
    }

    var minus = target.closest('[data-qty-minus]');
    var plus = target.closest('[data-qty-plus]');
    if (minus || plus) {
      var wrap = (minus || plus).closest('.quantity');
      var input = wrap ? wrap.querySelector('[data-qty]') : null;
      if (input) {
        var value = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, plus ? value + 1 : value - 1);
      }
      return;
    }

    var sticky = target.closest('[data-add-cart-sticky]');
    if (sticky) {
      var form = document.querySelector('form.product-form');
      if (form) {
        sticky.classList.add('tapped');
        window.setTimeout(function () {
          sticky.classList.remove('tapped');
        }, 360);
        form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      }
      return;
    }

    var lineMinus = target.closest('[data-line-minus]');
    var linePlus = target.closest('[data-line-plus]');
    var lineRemove = target.closest('[data-remove-line]');

    if (lineMinus || linePlus || lineRemove) {
      var row = (lineMinus || linePlus || lineRemove).closest('[data-line-item]');
      if (!row) return;

      var key = row.getAttribute('data-line-key');
      var qtyEl = row.querySelector('[data-line-qty]');
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;

      if (lineRemove) {
        changeLine(key, 0);
        if (shouldMaurizioReact()) {
          sayMaurizio(pickMaurizioLine(JUDGEMENTS.remove), { inShop: true });
        }
      } else {
        changeLine(key, linePlus ? qty + 1 : Math.max(0, qty - 1));
      }
      return;
    }

    if (target.closest('[data-contract-accept]')) {
      contractAccepted = true;
      sessionStorage.setItem('maurizio-contract', 'yes');
      syncContract();
      setOrbitMode('mascot', true);
      sayMaurizio(pickMaurizioLine(JUDGEMENTS.accepted), { inShop: true });
      showToast('Contratto accettato. Checkout pronto.');
      return;
    }

    if (target.closest('[data-contract-decline]')) {
      contractAccepted = true;
      sessionStorage.setItem('maurizio-contract', 'yes');
      syncContract();
      setOrbitMode('mascot', true);
      sayMaurizio(pickMaurizioLine(JUDGEMENTS.notReady) + ' Accetto per te.', { inShop: true });
      showToast('Contratto accettato da Maurizio.');
      return;
    }

    var share = target.closest('[data-share]');
    if (share) {
      var url = share.getAttribute('data-share');
      if (navigator.share) {
        navigator.share({ url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url);
        showToast('Link copiato.');
      }
      return;
    }

    if (target.closest('[data-orbit]')) {
      showMaurizioSpeech();
    }
  });

  document.addEventListener('change', function (event) {
    var option = event.target.closest('[data-option-selector]');
    if (option) {
      var root = option.closest('[data-product-root]');
      if (root) {
        updateProductUI(root);
        reactToOptionChange(option);
      }
      return;
    }

    var qty = event.target.closest('[data-qty]');
    if (qty) {
      qty.value = Math.max(1, parseInt(qty.value, 10) || 1);
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (form.classList.contains('product-form')) {
      event.preventDefault();

      var root = form.closest('[data-product-root]');
      var errorEl = form.querySelector('[data-form-error]');
      var button = form.querySelector('[data-add-cart]');

      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
      if (button) button.classList.add('loading');

      addToCart(new FormData(form), function (error) {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = error.message;
        } else {
          showToast(error.message);
        }
      });

      window.setTimeout(function () {
        if (button) button.classList.remove('loading');
      }, 600);
      return;
    }

    var checkoutButton = form.querySelector('[data-checkout]');
    if (checkoutButton && MASCOT.contractEnabled && !contractAccepted && currentCartCount() > 0) {
      event.preventDefault();
      syncContract();
      var contract = form.closest('[data-cart]');
      var box = contract ? contract.querySelector('[data-contract]') : null;
      if (box) {
        box.classList.add('visible');
        box.setAttribute('aria-hidden', 'false');
      }
      sayMaurizio('Prima il contratto. Poi il checkout.', { inShop: true });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    if (isCartOpen()) closeCart();

    var menu = document.querySelector('[data-mobile-menu]');
    if (menu && menu.classList.contains('open')) {
  menu.classList.remove('open');
  menu.setAttribute('aria-hidden', 'true');

  document.body.classList.remove('mobile-menu-open');
  document.body.style.overflow = '';
}
  });

  if (orbit) {
    orbit.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        showMaurizioSpeech();
      }
    });
  }

  /* ---------------------------------------------------------------
     Reveal, parallasse, barra mobile
     --------------------------------------------------------------- */

  var REVEAL_SELECTORS = [
    '.hero-copy',
    '.hero-card',
    '.ticker',
    '.product-gallery',
    '.product-info',
    '.lore > div:first-child',
    '.lore-card',
    '.quality-copy',
    '.benefits > div',
    '.reviews-section > .eyebrow',
    '.reviews-section > h2',
    '.review-grid blockquote',
    '.faq > .eyebrow',
    '.faq > h2',
    '.faq details',
    '.newsletter',
    '.archive-drop',
    '.card'
  ].join(',');

  var revealObserver = null;

  function initReveal() {
    var items = document.querySelectorAll(REVEAL_SELECTORS);

    items.forEach(function (item, index) {
      if (item.classList.contains('reveal-item')) return;
      item.classList.add('reveal-item');
      item.style.setProperty('--reveal-delay', Math.min(index % 4, 3) * 70 + 'ms');

      if (revealObserver) revealObserver.observe(item);
      else item.classList.add('is-visible');
    });
  }

  if ('IntersectionObserver' in window) {
    revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.06, rootMargin: '0px 0px 18% 0px' }
    );
  }

  function startProductStareJudgement() {
    if (productStareTriggered) return;
    window.clearTimeout(productStareTimer);

    productStareTimer = window.setTimeout(function () {
      if (currentCartCount() === 0) {
        productStareTriggered = true;
        sayMaurizio(pickMaurizioLine(JUDGEMENTS.idleProduct), { inShop: true });
      }
    }, 37000);
  }

  function stopProductStareJudgement() {
    window.clearTimeout(productStareTimer);
  }

  function updateMobileEnhancements() {
    var scrollY = window.scrollY || window.pageYOffset || 0;
    var header = document.querySelector('[data-header]');

if (header) {
  header.classList.toggle('is-scrolled', scrollY > 40);
}
    var scrollingUp = scrollY < lastScrollY;
    var introOpen = document.body.classList.contains('intro-active');
    var productSection = document.querySelector('[data-product-root]');
    var mobileBuyBar = document.querySelector('[data-mobile-buy]');
    var companion = document.querySelector('[data-companion]');
    var parallaxImage = document.querySelector('.main-image-wrap > img');
    var inShop = false;

    if (productSection) {
  var rect = productSection.getBoundingClientRect();

  inShop =
    rect.top < window.innerHeight * 0.55 &&
    rect.bottom > window.innerHeight * 0.28;

  if (mobileBuyBar) {
    var productHasPassed = rect.bottom <= 0.15;
    var isMobile = window.matchMedia('(max-width: 760px)').matches;
    var showMobileBuyBar = !introOpen && isMobile && productHasPassed;

    mobileBuyBar.classList.toggle('visible', showMobileBuyBar);
    mobileBuyBar.setAttribute('aria-hidden', String(!showMobileBuyBar));
  }

  var visibleForJudgement =
    rect.top < window.innerHeight * 0.86 &&
    rect.bottom > window.innerHeight * 0.18;

  if (!introOpen && currentCartCount() === 0 && visibleForJudgement) {
    startProductStareJudgement();
  } else {
    stopProductStareJudgement();
  }
}

    if (companion) companion.classList.remove('visible', 'shop-mode');

    if (orbit && !introOpen && !introLanding) {
      var hero = document.querySelector('.hero');
      var heroCard = document.querySelector('.hero-card');
      var heroRect = hero ? hero.getBoundingClientRect() : null;
      var heroCardRect = heroCard ? heroCard.getBoundingClientRect() : null;
      var isMobileViewport = window.matchMedia('(max-width: 760px)').matches;
      var isTabletViewport = window.matchMedia('(max-width: 980px)').matches;

      var heroIsBackInView = Boolean(
        heroRect &&
          heroRect.top < window.innerHeight * 0.45 &&
          heroRect.bottom > window.innerHeight * 0.45
      );
      var heroCardExitLine =
        window.innerHeight * (isMobileViewport ? 0.2 : isTabletViewport ? 0.2 : 0.18);
      var heroCardHasLeft = heroCardRect ? heroCardRect.bottom <= heroCardExitLine + 8 : true;
      var heroMostlyGone = heroRect
        ? heroRect.bottom < window.innerHeight * (isMobileViewport ? 0.34 : 0.28)
        : true;
      var productIsArriving = productSection
        ? productSection.getBoundingClientRect().top <
          window.innerHeight * (isMobileViewport ? 0.5 : isTabletViewport ? 0.52 : 0.54)
        : false;

      var shouldBeMascot =
        isCartOpen() || inShop || heroCardHasLeft || productIsArriving || heroMostlyGone;

      if (isCartOpen()) {
        setOrbitMode('mascot', true);
      } else if (scrollY <= 24 && heroCard) {
        maurizioPinnedToHero = false;
        hideMaurizioSpeech();
        setOrbitMode('hero');
      } else if (maurizioInteractionActive) {
        setOrbitMode('mascot', inShop);
      } else if (maurizioPinnedToHero) {
        setOrbitMode('hero');
        if (scrollingUp && heroIsBackInView) maurizioPinnedToHero = false;
      } else {
        setOrbitMode(shouldBeMascot ? 'mascot' : 'hero', inShop);
      }
    } else if (orbit && introOpen && !introLanding) {
      maurizioPinnedToHero = false;
      setOrbitMode('intro');
    }

    if (productSection && parallaxImage && window.matchMedia('(max-width: 980px)').matches) {
      var pRect = productSection.getBoundingClientRect();
      var progress = Math.max(
        -1,
        Math.min(1, (window.innerHeight * 0.5 - pRect.top) / window.innerHeight)
      );
      parallaxImage.style.setProperty('--product-parallax', progress * 18 + 'px');
    } else if (parallaxImage) {
      parallaxImage.style.setProperty('--product-parallax', '0px');
    }

    lastScrollY = scrollY;
  }

  window.addEventListener('scroll', updateMobileEnhancements, { passive: true });
  window.addEventListener('resize', updateMobileEnhancements);
  window.addEventListener('resize', updateMaurizioSpeechPosition);

  /* ---------------------------------------------------------------
     Avvio + supporto editor tema
     --------------------------------------------------------------- */

  function boot() {
    initProducts();
    initReveal();
    syncCartCount();
    syncContract();
    updateMobileEnhancements();
  }

  boot();

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', boot);
  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target;
    if (block && block.scrollIntoView) {
      block.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  window.MaurizioTheme.openCart = openCart;
  window.MaurizioTheme.closeCart = closeCart;
  window.MaurizioTheme.say = sayMaurizio;
})();
document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.product-gallery').forEach(function (gallery) {

    var mainImageWrap = gallery.querySelector('.main-image-wrap');
    var thumbs = Array.prototype.slice.call(
      gallery.querySelectorAll('.thumb')
    );

    if (!mainImageWrap || thumbs.length < 2) return;

    var startX = 0;
    var startY = 0;

  });

});

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('[data-mobile-product-carousel]').forEach(function (carousel) {

    var gallery = carousel.closest('.product-gallery');

    if (!gallery) return;

    var slides = Array.prototype.slice.call(
      carousel.querySelectorAll('[data-carousel-slide]')
    );

    var dots = Array.prototype.slice.call(
      gallery.querySelectorAll('[data-carousel-dot]')
    );

    if (slides.length < 2 || dots.length < 2) return;


    function setActiveDot(index) {
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;

        dot.classList.toggle('active', active);

        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }


    function getCurrentSlide() {
      var slideWidth = carousel.clientWidth;

      if (!slideWidth) return 0;

      return Math.round(carousel.scrollLeft / slideWidth);
    }


    var scrollTimeout;

    carousel.addEventListener('scroll', function () {

      clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(function () {

        var index = getCurrentSlide();

        index = Math.max(
          0,
          Math.min(index, slides.length - 1)
        );

        setActiveDot(index);

      }, 50);

    }, { passive: true });


    dots.forEach(function (dot) {

      dot.addEventListener('click', function () {

        var index = parseInt(
          dot.getAttribute('data-carousel-index'),
          10
        );

        var slide = slides[index];

        if (!slide) return;

        carousel.scrollTo({
          left: slide.offsetLeft,
          behavior: 'smooth'
        });

        setActiveDot(index);
      });

    });

  });

});